import * as React from 'react';
import ErrorMessagesComponent from '../commons/error-messages/ErrorMessages.component';
import ResultPageCardComponent from '../commons/result-page/ResultPageCard.Component';

interface Props {
  handleSubmit: () => void;
  handleChange: (key: string) => (value: string) => void;
  errorMessage: {};
  success: boolean;
}

class PasswordResetComponent extends React.PureComponent<Props> {

  public render(): React.ReactNode {
    const message = `Guarda la contraseña en un lugar seguro.
    Te recomedamos usar un gestor de contraseñas para que no te vuelva a suceder esto.`;
    return this.props.success ? 
    (
      <ResultPageCardComponent
        title="¡Tu contraseña se ha cambiado correctamente!"
        message={message}
      />
    ) :
    (
      <section className="show-investor-deck-component">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-8">
              <h1 className="deco-title f-w-100 primary-font">
                Recuperar Contraseña
              </h1>
              <div className="gap-20" />
            </div>
            <div className="col-sm-12 col-md-4">
              <p className="breadcrumb text-right">
                Inicio > recuperar contraseña
              </p>
            </div>
          </div>
          <div className="row row-eq-height">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.props.handleSubmit();
              }}
            >
              <h4 className="f-w-100 invest-title">
                <strong>¡Ya casi estamos!</strong>
              </h4>
              <div className="gap-20" />
              <p>
                Introduce la nueva contraseña y habremos terminado.
              </p>
              <div className="gap-20" />
              <div className="md-input">
                <input
                  className="md-form-control"
                  required={true}
                  type="password"
                  onChange={(e) => this.props.handleChange('password')(e.target.value)}
                />
                <span className="highlight" />
                <span className="bar" />
                <label>
                  Introduce tu nueva contraseña *
                </label>
              </div>
              <div className="gap-20" />
              <div className="md-input">
                <input
                  className="md-form-control"
                  required={true}
                  type="password"
                  onChange={(e) => this.props.handleChange('passwordConfirmation')(e.target.value)}
                />
                <span className="highlight" />
                <span className="bar" />
                <label>
                Confirma tu nueva contraseña *
                </label>
              </div>
              <div className="gap-20" />
              <button
                type="submit"
                className="btn btn-primary"
              >
                Enviar
              </button>
              <div className="gap-20" />
              <ErrorMessagesComponent
                errorMessage={this.props.errorMessage}
              />
            </form>
          </div>
        </div>
      </section>
    );
  }
}

export default PasswordResetComponent;



// WEBPACK FOOTER //
// ./src/modules/password-reset/PasswordReset.component.tsx